import * as React from 'react'
import { SpinInput } from '@components/controls/spin-input'
import { useFormContext, useWatch } from 'react-hook-form'
import { ImprovementDetailsFormInputs } from '@modules/reservations/improvements/kinds/base-improvements/base-improvement-details-modal'
import { FormError } from '@components/form-controls/form-error'

export const ImprovementAmountChange = (): JSX.Element => {
  const { control, setValue } = useFormContext<ImprovementDetailsFormInputs>()

  const amount = useWatch({ control, name: 'amount' })
  const maxAmount = useWatch({ control, name: 'maxAmount' })
  const minAmount = useWatch({ control, name: 'minAmount' })

  const handleAmountChange = value => {
    setValue('amount', value)
  }

  return (
    <>
      <div className="mb-2 mb-sm-0 improvements__modal__amount-change">
        <strong className="text-darker-gray text-sm-end d-block fw-medium mb-1">Ilość ulepszeń:</strong>
        <SpinInput
          value={amount}
          min={minAmount ?? 1}
          max={maxAmount}
          className="mx-5 form-control-height-lg"
          readOnly={true}
          onIncrement={handleAmountChange}
          onDecrement={handleAmountChange}
        />
      </div>
      <FormError inputName="amount" className="mt-n3" />
    </>
  )
}
